import {configureStore} from "@reduxjs/toolkit";
import user from "./slices/user";
import flashMessages from "./slices/flashMessages";

export default configureStore({
  reducer: {
    user: user,
    flashMessages: flashMessages,
  },
});
